import React, { useCallback, useEffect, useRef, useState } from 'react'
import Modal from '../../components/Display/Modal'
import { ColumnsTable, HeaderActions, IDealer, State } from 'safe'
import {
  fetchDealers,
  createDealer,
  updateDealer,
  removeDealer,
  onEnableDealer,
  deleteDocumentDealer,
} from '../../redux/actions/dealers'
import { connect, ConnectedProps } from 'react-redux'
import Table from '../../components/Display/Table'
import DealersForm from './DealersForm'
import ProviderAnimation from '../../assets/animations/provider_animation.json'
import DocumentAnimation from '../../assets/animations/empty_document.json'
import { AnimatePresence, motion } from 'framer-motion'
import Empty from '../../components/Display/Empty'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import FloatingMenu from '../../components/Display/FloatingMenu'
import { HiDotsVertical, HiOutlinePencil, HiPencil } from 'react-icons/hi'
import { ColumnItemWrapper } from '../../components/General/ColumnItemWrapper'
// import YAML from 'json-to-pretty-yaml'
import { useLocalStorageState } from '../../hooks/useLocalStorageState'
import SearchDealersForms from './SearchDealersForm'
import { Accounts, AddAccounts } from './Accounts'
import ModalConfirm from '../../components/Display/ModalConfirm'
import { DataTabView } from '../../components/Display/ViewWithTabs'
import ModalViewWithTabs from '../../components/Display/ModalViewWithTabs'
import pdfImage from '../../assets/images/pdf-icon-png-2082.png'
import docxImage from '../../assets/images/word-image.png'
import excelImage from '../../assets/images/excel-image.png'
import fileBlueImage from '../../assets/images/documents-image.png'
import { HeaderProps } from '../../components/Layout/Header'
import { GrAdd, GrFormAdd } from 'react-icons/gr'
import { IoMdAdd } from 'react-icons/io'
import Button from '../../components/General/Button'
import FloatingForm from '../../components/Display/FloatingForm'
import axios from 'axios'
import { FiTrash2 } from 'react-icons/fi'
import { BiPlus } from 'react-icons/bi'
import AccountsUpdate from './AccountsUpdate'
import AdvancedClientsForm from '../../components/Display/AdvancedClientsForm'
import { deflateRaw } from 'zlib'
import { IoAdd } from 'react-icons/io5'
import { FaTrashAlt } from 'react-icons/fa'

interface IUnionAccount {
  id: string
  name: string
  accountName: string
  number: string
  method: string
}

const Dealers: React.FC<DealersProps & PropsFromRedux> = ({
  dealers,
  numberOfPages,
  setHeaderActions,
  fetchDealers,
  createDealer,
  updateDealer,
  removeDealer,
  onEnableDealer,
  deleteDocumentDealer,
}) => {
  const [loading, setLoading] = useState<boolean>(false)
  const [modal, setModal] = useState<boolean>(false)
  const [searchModal, setSearchModal] = useState<boolean>(false)
  const [modalFromRow, setModalFromRow] = useState(false)
  const [selected, setSelected] = useState<IDealer | null>(null)
  const [activeMenu, setActiveMenu] = useState<number>(-1)
  const [searchParams, setSearchParams] = useState<string[]>([])
  const [currentPage, setCurrentPage] = useState<number>(0)
  const [userConfig] = useLocalStorageState('user-config')
  const [accountsModal, setAccountsModal] = useState(false)
  const [confirmModal, setConfirmModal] = useState<boolean>(false)
  const [confirmModalAccount, setConfirmModalAccount] = useState<boolean>(false)
  const [dealerToDelete, setDealerToDelete] = useState<object>({})
  const [dataWithTabs, setDataWithTabs] = useState<DataTabView[]>([])
  const [showDocuments, setShowDocuments] = useState<boolean>(false)
  const [selectedDocument, setSelectedDocument] = useState<any>(null)
  const [selectedAccountToDeleteId, setSelectedAccountToDeleteId] = useState<
    string | null
  >(null)
  const { addAlert } = useSnackBars()

  const refInputSearch = useRef<HTMLInputElement | null>(null)

  const [showModalAccountForm, setShowModalAccountForm] = useState<boolean>(
    false
  )

  const [conditionalColumns] = useState<string[]>([
    'name',
    'accountName',
    'number',
    'method',
  ])

  const [columnAccount] = useState<any[]>([
    'Titular',
    'Banco',
    'Cuenta',
    'Modalidad de pago',
  ])

  const [unionAccounts, setUnionAccounts] = useState<IUnionAccount[]>([])

  const [selectedEditAccount, setSelectedEditAccount] = useState<any | null>(
    null
  )

  const [
    showModalAccountFormEdit,
    setShowModalAccountFormEdit,
  ] = useState<boolean>(false)

  const [fastSearch, setFastSearch] = useState<string>('')

  const server = process.env.REACT_APP_SERVER_URL

  // const getDealers = useCallback(async () => {
  //   setLoading(true)
  //   try {
  //     await fetchDealers(searchParams, [
  //       `pageNumber=${currentPage + 1}`,
  //       `pageSize=${userConfig.rowsPerPage}`,
  //     ])
  //   } catch (e) {
  //     // console.log("server error")
  //   } finally {
  //     setLoading(false)
  //   }
  //   setLoading(false)
  // }, [currentPage])

  const getDealers = async (
    params: string[] = searchParams,
    pageNumber: number = 0,
    fastParam = fastSearch
  ) => {
    const paginationParams = [
      `pageNumber=${pageNumber + 1}`,
      `pageSize=${userConfig.rowsPerPage}`,
    ]

    setFastSearch(fastParam)

    setCurrentPage(pageNumber)

    setSearchParams(params)

    setLoading(true)

    let newParams = [...params]

    if (fastParam) {
      newParams.push(`fastSearch=${fastParam}`)
    }

    await fetchDealers(newParams, [
      `pageNumber=${currentPage + 1}`,
      `pageSize=${userConfig.rowsPerPage}`,
    ])

    setLoading(false)
  }

  useEffect(() => {
    getDealers()
  }, [])

  const onFilterFloatingOptions = (options, dealer) => {
    return options
    // if (dealer.enable) return options
    // return {
    //   onEnable: async () => {
    //     addAlert({ message: 'Habilitando proveedor...', status: 'loading' })
    //     try {
    //       await onEnableDealer(dealer.id, true)
    //       // await onEnableClient(client.id, true)
    //       addAlert({
    //         message: 'Proveedor habilitado con exito',
    //         status: 'success',
    //       })
    //       // setMenuVisible(-1)
    //       setActiveMenu(-1)
    //     } catch (err) {
    //       addAlert({ message: 'Error al habilitar proveedor', status: 'error' })
    //     }
    //   },
    // }
  }

  const returnNameByRegex = (url: string): string => {
    let getTypeFolder = (url.match(/\/provider\/.+\//g) || [])[0]?.split('/')[2] || ''
    let regexValue = `((?<=\\/${getTypeFolder}\\/).+)(?=\\.)`
    console.log('get type', regexValue)
    let newNameRegex = new RegExp(regexValue, 'g')
    let name = (url.match(newNameRegex) || [])[0] || ''
    return name
  }

  const getAndFormatAccounts = async (dealer) => {
    let response = await axios.get(
      `${server}/thirdparty/provider?id=${dealer.id}`
    )
    const { provider } = response.data
    console.log('provider..', provider)
    setSelected(provider)
    // await axios.get(`${server}/thirdparty/provider-accounts/national`)
    // await axios.get(`${server}/thirdparty/provider-accounts/otherBankAccount`)
    // await axios.get(`${server}/thirdparty/provider-accounts/instantPayment`)

    setUnionAccounts([
      ...provider.accounts.instantPayment.map((v) => ({
        ...v,
        id: v.id,
        name: v.name,
        accountName: v.bank,
        number: v.phone,
        method: 'Pago móvil',
        type: 'INSTANT_PAYMENT',
      })),
      ...provider.accounts.national.map((v) => ({
        ...v,
        id: v.id,
        name: v.name,
        accountName: v.bank,
        number: v.accountNumber,
        method: 'Transferencia',
        type: 'BANK_ACCOUNT',
      })),
      ...provider.accounts.other.map((v) => ({
        ...v,
        id: v.id,
        name: v.name,
        accountName: v.paymentMethod,
        number: v.description,
        method: 'Otro',
        type: 'OTHER_ACCOUNT',
      })),
    ])
    setAccountsModal(true)
  }

  const columns: ColumnsTable[] = [
    {
      title: 'Nombre',
      dataIndex: 'businessName',
      key: 'businessName',
      render: (name: any, client: any) => (
        <ColumnItemWrapper subElement="paragraph">
          {client.document.documentType === 'J' ||
          client.document.documentType === 'C'
            ? client.businessName
            : client.name}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Teléfono',
      dataIndex: 'phone',
      key: 'phone',
      width: 140,
      render: (x: any, dealer: any) => {
        if (!dealer?.phone1 || dealer?.phone1?.includes("null")) return ""

        return (
        <ColumnItemWrapper>
          <p
            style={{
              whiteSpace: 'pre',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {/* {dealer?.phones
              .map((phone) => {
                // console.log('phone: ', phone)
                return phone.number
                  ? `${phone.country.dial_code || phone.country.dialCode} ${
                      phone.number
                    }`
                  : 'N/A'
              })
              .join('\n')} */}

            {dealer?.phone1 && dealer?.phone
              ? [`+${dealer.phone1}`, `+${dealer.phone2}`].join('\n')
              : `+${dealer?.phone1}`}
          </p>
        </ColumnItemWrapper>

        )
      }
    },
    {
      title: 'Documento',
      dataIndex: 'document',
      key: 'document',
      render: (x: any, dealer: any) => (
        <ColumnItemWrapper subElement="paragraph">
          {dealer?.document.documentType}-{dealer.document.document}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Dirección',
      dataIndex: 'address',
      key: 'address',
      render: (x: any, dealer: any) => (
        <ColumnItemWrapper subElement="paragraph">
          {[
            dealer?.address.city,
            dealer?.address.state,
            dealer?.address.postalCode,
          ].join(', ')}
        </ColumnItemWrapper>
      ),
    },
    {
      title: 'Correo',
      dataIndex: 'email',
      key: 'email',
      render: (mail) => (
        <ColumnItemWrapper subElement="paragraph">
          {mail ? mail : 'N/A'}
        </ColumnItemWrapper>
      ),
    },
    {
      title: '',
      dataIndex: 'id',
      align: 'right',
      width: 50,
      key: 'actions',
      render: (id: number, dealer) => (
        <ColumnItemWrapper floatingMenu>
          <FloatingMenu
            visible={id === activeMenu}
            onClose={() => setActiveMenu(-1)}
            options={onFilterFloatingOptions(
              {
                onSendWhatsappMessage: async () => {
                  const [left, right] = dealer?.phone1?.split(' ')

                  let number = `${left}${right}`

                  if (/^0/.test(right)) {
                    number = `${left}${right.slice(1)}`
                  }

                  let response = await axios.get(`${server}/config/tenant`)

                  let text = response?.data?.userConf?.whatsappGreeting

                  if (text) {
                    window.open(
                      `https://api.whatsapp.com/send?phone=${number}&text=${text}`,
                      '_blank'
                    )
                  } else {
                    window.open(
                      `https://api.whatsapp.com/send?phone=${number}`,
                      '_blank'
                    )
                  }
                },
                onEdit: () => {
                  setSelected(dealer)
                  setModal(true)
                },
                onDelete: async () => {
                  setConfirmModal(true)
                  setDealerToDelete(dealer)

                  // await onDelete(dealer)
                  // if (currentPage === 0) {
                  //   setSearchParams([])
                  //   setLoading(true)
                  //   await fetchDealers([], [
                  //     `pageNumber=${currentPage + 1}`,
                  //     `pageSize=${userConfig.rowsPerPage}`,
                  //   ])
                  //   setLoading(false)
                  // } else {
                  //   setCurrentPage(0)
                  // }
                },
                onBank: async () => {
                  getAndFormatAccounts(dealer)
                },
                // onDisable: async () => {
                //   addAlert({
                //     message: 'Deshabilitando proveedor...',
                //     status: 'loading',
                //   })
                //   try {
                //     await onEnableDealer(dealer.id, false)
                //     addAlert({
                //       message: 'Proveedor deshabilitado con éxito',
                //       status: 'success',
                //     })
                //     // setMenuVisible(-1)
                //     setActiveMenu(-1)
                //   } catch (err) {
                //     addAlert({
                //       message: 'Error al deshabilitar proveedor',
                //       status: 'error',
                //     })
                //   }
                // },
                // onFiles: () => {
                //   setSelected(dealer)
                //   setShowDocuments(true)
                // },
              },
              dealer
            )}
          >
            <HiDotsVertical
              className="cursor-pointer"
              onClick={() => setActiveMenu(id)}
            />
          </FloatingMenu>
        </ColumnItemWrapper>
      ),
    },
  ]

  const accountsColumns = [
    {
      title: 'Nombre',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Banco',
      dataIndex: 'accountName',
      key: 'accountName',
    },
    {
      title: 'Cuentas',
      dataIndex: 'number',
      key: 'number',
    },
    {
      title: 'Modalidad',
      dataIndex: 'method',
      key: 'method',
    },
    {
      title: '',
      dataIndex: 'edit',
      key: 'edit',
      render: (id: number, record: any) => {
        return (
          <HiPencil
            className="text-primary"
            onClick={() => {
              console.log('RECORD', record)
              setSelectedEditAccount({ ...record, type: record?.type })
              setShowModalAccountFormEdit(true)
            }}
          />
        )
      },
    },
    {
      title: '',
      dataIndex: 'delete',
      key: 'delete',
      render: (id: number, record: any) => {
        return (
          <FaTrashAlt
            className="text-danger"
            onClick={() => {
              setSelectedAccountToDeleteId(record.id)
              setConfirmModalAccount(true)
            }}
          />
        )
      },
    },
  ]

  const getOrderKeys = (key: string) => {
    if (key === 'document') return ['document', 'document']
    if (key === 'address') return ['address', 'street']
    if (key === 'phone') return ['phones', '0', 'number']
    return [key]
  }

  const renderRows = () => {
    return unionAccounts.map((values, idx) => {
      return (
        <div className="flex mb-2" key={idx}>
          {conditionalColumns.map((v) => (
            <div className="w-28 mr-6" style={{ whiteSpace: 'normal' }}>
              <label style={{ lineBreak: 'anywhere' }} className="text-xs">
                {conditionalColumns.some((x) => x === v) && values[v]}
              </label>
            </div>
          ))}
          <div className="flex">
            <HiOutlinePencil
              size={20}
              className="text-primary-700 mr-5 cursor-pointer"
              onClick={() => {
                setSelectedEditAccount(values)
                setShowModalAccountFormEdit(true)
              }}
            />
            <FiTrash2
              size={20}
              color="red"
              className="cursor-pointer"
              onClick={async () => {
                setSelectedAccountToDeleteId(values.id)
                setConfirmModalAccount(true)
              }}
            />
          </div>
        </div>
      )
    })
  }

  useEffect(() => {
    // fetchDealers()
    setHeaderActions({
      addAction: () => setModal(true),
      // searchAction: () => setSearchModal(true),
      advancedSearch: async (value) => {
        if (typeof value === 'boolean') {
          setSearchModal(value)
          return
        }

        getDealers([], 0, value)

        // setSearchParams([`fastSearch=${value}`])
        // if (currentPage === 0) {
        //   setLoading(true)
        //   await fetchDealers(
        //     [`fastSearch=${value}`],
        //     [`pageNumber=${1}`, `pageSize=${userConfig.rowsPerPage}`]
        //   )
        //   setLoading(false)
        // } else {
        //   setCurrentPage(0)
        // }
      },
      // onSearch: {
      //   action: async (value) => {
      //     let valueWithoutSpaces = value.replace(/\s{2,}/g, ' ').trim()
      //     await fetchDealers(
      //       [`value=${valueWithoutSpaces}`],
      //       [`pageNumber=${1}`, `pageSize=${userConfig.rowsPerPage}`]
      //     )
      //   },
      //   display: true,
      //   // icon: null,
      //   placeholder: 'Buscar. Ej: J88888888',
      //   ref: refInputSearch,
      //   tooltipMessage:
      //     'Puede buscar por documento, correo, nombre y apellidos, nombre comercial o dirección fiscal',
      // },
      cleanFilters: {
        sort: () => {
          console.log('sort clean')
        },
        search: async () => {
          // setSearchParams([])
          // if (currentPage === 0) {
          //   setLoading(true)
          //   await fetchDealers(
          //     [],
          //     [`pageNumber=${1}`, `pageSize=${userConfig.rowsPerPage}`]
          //   )
          //   setLoading(false)
          // }
          // setCurrentPage(0)
          getDealers([], 0)
        },
        isSearch: Boolean(searchParams.length > 0),
      },
    })
    return () => {
      if (refInputSearch && refInputSearch.current) {
        refInputSearch.current.value = ''
        refInputSearch.current = null
      }
      setHeaderActions(null)
    }
    //eslint-disable-next-line
  }, [
    currentPage,

    fetchDealers,
    searchParams,
    setHeaderActions,
    userConfig.rowsPerPage,
  ])

  const onDelete = async (values) => {
    const _values: IDealer = {
      ...values,
    }
    setLoading(true)
    try {
      addAlert({ message: 'Eliminando proveedor...', status: 'loading' })
      await removeDealer(_values)
      addAlert({ message: 'Proveedor eliminado con éxito', status: 'success' })
    } catch (e: any) {
      let response = e?.response?.data?.message
      if (response.includes('associated accounting records')) {
        addAlert({
          message:
            'No se puede eliminar este proveedor porque tiene registros contables asociados.',
          status: 'error',
        })
      } else {
        // console.log("catch")
        addAlert({ message: 'Error al eliminar proveedor', status: 'error' })
      }
    } finally {
      // console.log('finally')
      setLoading(false)
    }
  }

  const pressRow = (dealer) => {
    console.log('delaerss...', dealers)
    let dealerDetails = { title: '', data: '' }
    let accountDetails = { title: '', data: '' }
    dealerDetails.title = 'Proveedor'
    dealerDetails.data += `Documento: ${dealer.document.documentType}-${dealer.document.document}\n`
    dealer.document.documentType.match(/([V]|[E]|[G]|[P])/) &&
      (dealerDetails.data += `Nombres: ${dealer.name}\n`)
    dealer.document.documentType.match(/([V]|[E]|[G]|[P])/) &&
      (dealerDetails.data += `Apellidos: ${dealer.surname}\n`)
    dealer.document.documentType.match(/([J]|[C])/) &&
      (dealerDetails.data += `Razón Social: ${dealer.businessName}\n`)
    dealer.document.documentType.match(/([J]|[C])/) &&
      (dealerDetails.data += `Nombre Comercial: ${
        dealer?.commercialName || ''
      }\n`)
    dealer.emaildealerDetails += `Correo: ${dealer.email}\n`
    dealer.address.street &&
      (dealerDetails.data += `Calle: ${dealer.address.street}\n`)
    dealer.address.avenue &&
      (dealerDetails.data += `Avenida: ${dealer.address.avenue}\n`)
    dealer.address.building &&
      (dealerDetails.data += `Edificio: ${dealer.address.building}\n`)
    dealer.address.neighborhood &&
      (dealerDetails.data += `Sector: ${dealer.address.neighborhood}\n`)
    dealerDetails.data += `Ciudad: ${dealer.address.city}\n`
    dealerDetails.data += `Estado: ${dealer.address.state}\n`
    // dealerDetails.data += `País: ${dealer.address.country}\n`
    dealerDetails.data += `Código Postal: ${dealer.address.postalCode}\n`
    dealerDetails.data += `Dirección Fiscal: ${dealer.address.fiscalAddress}\n`
    dealerDetails.data += `Contribuyente Especial: ${
      dealer.contributingSpecial ? 'Sí' : 'No'
    }\n`
    dealer.contributingSpecial &&
      (dealerDetails.data += `Porcentaje de Retención: ${dealer.withholdingTax}%\n`)
    // for (let i = 0; i < dealer.phones.length; i++) {
    //   if (i === 0) {
    //     dealerDetails.data += `Telefonos:  ${
    //       dealer.phones[i].country.dialCode ||
    //       dealer.phones[i].country.dial_code
    //     } ${dealer.phones[i].number}\n`
    //   } else {
    //     dealerDetails.data += `\t\t\t${
    //       dealer.phones[i].country.dialCode ||
    //       dealer.phones[i].country.dial_code
    //     } ${dealer.phones[i].number}\n`
    //   }
    // }

    // if (
    //   dealer.accounts?.national?.length > 0 ||
    //   dealer.accounts?.instantPayment?.length > 0 ||
    //   dealer.accounts?.other?.length > 0
    // ) {
    //   accountDetails.title = `Cuentas`
    // }

    // if (dealer.accounts?.national?.length > 0) {
    //   accountDetails.data += 'Cuentas Nacionales\n'
    //   for (const account of dealer.accounts?.national) {
    //     accountDetails.data += `  * Banco: ${account.bank}\n`
    //     accountDetails.data += `\tDocumento: ${account.document.documentType}-${account.document.document}\n`
    //     accountDetails.data += `\tNombre: ${account.name}\n`
    //     accountDetails.data += `\tTipo de cuenta: ${account.typeAccount}\n`
    //     accountDetails.data += `\tNúmero de cuenta: ${account.accountNumber}\n`
    //     account.email && (accountDetails.data += `\tCorreo: ${account.email}\n`)
    //     accountDetails.data += '\n'
    //   }
    // }

    // if (dealer.accounts?.instantPayment?.length > 0) {
    //   accountDetails.data += 'Pagos Móviles\n'
    //   for (const account of dealer.accounts?.instantPayment) {
    //     accountDetails.data += `  * Banco: ${account.bank}\n`
    //     accountDetails.data += `\tDocumento: ${account.document.documentType}-${account.document.document}\n`
    //     accountDetails.data += `\tNombre: ${account.name}\n`
    //     accountDetails.data += `\tTeléfono: ${account.phone}\n`
    //     account.email && (accountDetails.data += `\tCorreo: ${account.email}\n`)
    //     accountDetails.data += '\n'
    //   }
    // }

    // if (dealer.accounts?.other?.length > 0) {
    //   accountDetails.data += 'Otros medios de pagos\n'
    //   for (const account of dealer.accounts?.other) {
    //     accountDetails.data += `  * Método de Pago: ${account.paymentMethod}\n`
    //     accountDetails.data += `\tNombre: ${account.name}\n`
    //     accountDetails.data += `\tDescripción: ${account.description}\n`
    //     accountDetails.data += '\n'
    //   }
    // }

    const dataToShow =
      dealer.accounts?.national?.length > 0 ||
      dealer.accounts?.instantPayment?.length > 0 ||
      dealer.accounts?.other?.length > 0
        ? [dealerDetails, accountDetails]
        : [dealerDetails]
    setDataWithTabs(dataToShow)
    setModalFromRow(true)
  }

  const onSubmit = async (values) => {
    console.log('VER', values.dealerFile)
    // toUpperValues(values)
    console.log(JSON.stringify(values, null, 2))
    const fd = new FormData()
    setLoading(true)
    try {
      if (!values.id) {
        addAlert({ message: 'Creando proveedor...', status: 'loading' })
        const { phones, ...rest } = values
        const [phone1, phone2] = phones
        const _values: { provider: Omit<IDealer, 'id'> } = {
          ...rest,
          phone_1: `${phone1?.country?.id} ${phone1?.number || null}`,
          phone_2: phone2 ? `${phone2?.country?.id} ${phone2?.number}` : null,
        }
        console.log('_values', _values)
        if (values.dealerFile) {
          fd.append('media', values.dealerFile)
          fd.append('fileType', 'pdf')
          await createDealer(_values, true, fd)
          // if (currentPage === 0) {
          //   setLoading(true)
          //   fetchDealers(
          //     [],
          //     [
          //       `pageNumber=${currentPage + 1}`,
          //       `pageSize=${userConfig.rowsPerPage}`,
          //     ]
          //   )
          //   setLoading(false)
          // } else {
          //   setCurrentPage(0)
          // }
          // setSearchParams([])
          await getDealers([], 0)
          addAlert({ message: 'Proveedor creado con éxito', status: 'success' })
          setModal(false)
        } else {
          await createDealer(_values, false, fd)
          // if (currentPage === 0) {
          //   setLoading(true)
          //   fetchDealers(
          //     [],
          //     [
          //       `pageNumber=${currentPage + 1}`,
          //       `pageSize=${userConfig.rowsPerPage}`,
          //     ]
          //   )
          //   setLoading(false)
          // } else {
          //   setCurrentPage(0)
          // }
          // setSearchParams([])
          await getDealers([], 0)
          addAlert({ message: 'Proveedor creado con éxito', status: 'success' })
          setModal(false)
        }
      } else {
        // if (values.dealerFile) {
        // fd.append('media', values.dealerFile)
        // fd.append('fileType', 'pdf')
        addAlert({ message: 'Actualizando proveedor...', status: 'loading' })
        const { phones, ...rest } = values
        const [phone1, phone2] = phones
        const _values: { provider: IDealer } = {
          ...rest,
          phone_1: `${phone1?.country?.id} ${phone1?.number || null}`,
          phone_2: phone2
            ? `${phone2?.country?.id} ${phone2?.number || null}`
            : null,
        }
        await updateDealer(_values)
        addAlert({
          message: 'Proveedor actualizado con éxito',
          status: 'success',
        })
        setModal(false)
        // } else {
        //   addAlert({ message: 'Actualizando proveedor...', status: 'loading' })
        //   const _values: { provider: IDealer } = {
        //     provider: {
        //       ...values,
        //     },
        //   }
        //   await updateDealer(_values, false, fd)
        //   addAlert({
        //     message: 'Proveedor actualizado con éxito',
        //     status: 'success',
        //   })
        //   setModal(false)
        // }
      }
    } catch (e) {
      addAlert({
        message: 'Error al crear o actualizar proveedor',
        status: 'error',
      })
    } finally {
      setLoading(false)
      setSelected(null)
    }
  }

  return (
    <>
      <AnimatePresence>
        {dealers.length <= 0 && (
          <Empty
            animationProps={{
              animation: ProviderAnimation,
              width: 350,
              height: 350,
            }}
          >
            <p className="font-semibold max-w-xs text-center my-4 text-sm text-coolGray-500">
              Los proveedores son claves para mantener tu stock optimo, añadelos
              y comienza a comprar.
            </p>
          </Empty>
        )}
        {dealers.length > 0 && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <Table
              getOrderKeys={getOrderKeys}
              data={dealers}
              columns={columns}
              loading={loading}
              pageSelected={currentPage}
              setPageSelected={(page) => getDealers(searchParams, page)}
              onPressButton={pressRow}
              pages={numberOfPages}
            />
          </motion.div>
        )}
      </AnimatePresence>

      <Modal
        display={accountsModal}
        // modalClasses="w-3/6 py-4 px-12"
        scroll="scroll"
        onAccept={() => null}
        onClose={() => {
          setAccountsModal(false)
          // setSelected(null)
        }}
        xlClasses="xl:w-6/12"
        innerStyle={{ width: '100%' }}
      >
        <div>
          <div className="flex justify-between">
            <div>
              <h3
                className="text-primary dark:text-white"
                style={{ fontWeight: 700 }}
              >
                Cuentas
              </h3>
              <h3 style={{ fontWeight: 600 }}>
                {selected?.commercialName || selected?.businessName}
              </h3>
            </div>

            <Button
              type="primary"
              icon={<IoAdd color="white" />}
              onClick={() => setShowModalAccountForm(true)}
            >
              Añadir Cuenta
            </Button>
          </div>

          <div className="mt-4">
            <Table
              columns={accountsColumns}
              data={unionAccounts}
              showPagination={false}
            />
          </div>

          {/* {unionAccounts.length === 0 && (
            <div className="flex flex-row justify-between mt-5">
              <label className="xl:w-10/12">
                Aún no tienes cuentas agregadas, presiona el botón más para
                agregar una nueva
                {console.log('sel', selected)}
              </label>

              <div
                style={{
                  height: 34,
                  width: 34,
                  backgroundColor: '#1A47AA',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: 5,
                }}
                className="cursor-pointer"
                onClick={() => setShowModalAccountForm(true)}
              >
                <IoMdAdd size={20} className="text-white" />
              </div>
            </div>
          )} */}
          {/* 
          <div className="max-h-52 overflow-y-auto ml-5">
            {unionAccounts.length > 0 && (
              <div className="flex flex-row mt-7">
                {columnAccount.map((column) => (
                  <div className="w-28 mr-6">
                    <label className="text-xs">{column}</label>
                  </div>
                ))}
              </div>
            )}

            <div className="mt-2">{renderRows()}</div>
          </div> */}
          {/* 
          {unionAccounts.length > 0 && (
            <div className="flex justify-end items-center mt-10 mr-3">
              <label className="mr-3 text-white">Añadir</label>
              <div
                className="flex justify-center items-center bg-primary-1200 rounded cursor-pointer"
                style={{ height: 34, width: 34 }}
                onClick={() => setShowModalAccountForm(true)}
              >
                <IoMdAdd size={20} className="text-white" />
              </div>
            </div>
          )} */}

          {/* <div className="flex flex-row justify-end">
            <div
              style={{
                height: 34,
                width: 34,
                backgroundColor: '#1A47AA',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: 5,
                marginTop: 20,
              }}
              onClick={() => setShowModalAccountForm(true)}
            >
              <IoMdAdd size={20} className="text-white" />
            </div>
          </div> */}

          {/* <div className="h-px dark:bg-primaryGray-600 bg-primaryGray-700 col-span-12 mt-5"></div> */}

          {/* <div className="flex flex-row justify-center mt-5">
            <div className="w-2/4 mr-5 pl-1">
              <Button
                onClick={() => {
                  // if (onCancel) onCancel()
                }}
                type="outline"
                classes="w-full"
              >
                Cancelar
              </Button>
            </div>

            <div className="w-2/4 mr-5 pl-1">
              <Button
                type="primary"
                classes="w-full"
                htmlType="submit"
                // onClick={() => setAlreadySubmitted(true)}
              >
                Guardar
              </Button>
            </div>
          </div> */}
        </div>
        {/* <Accounts
          dealer={selected}
          setModal={setAccountsModal}
          onCancel={() => {
            setAccountsModal(false)
            setSelected(null)
          }}
          setSelected={setSelected}
        /> */}
      </Modal>

      <Modal
        display={showModalAccountForm}
        onClose={() => {
          // setAccountsModal(false)
          setShowModalAccountForm(false)
          // setSelected(null)
        }}
      >
        <AddAccounts
          dealer={selected}
          setModal={setShowModalAccountForm}
          getAccounts={getAndFormatAccounts}
          onCancel={() => {
            // setAccountsModal(false)
            setShowModalAccountForm(false)
            // setSelected(null)
          }}
          setSelected={setSelected}
          onCreated={(newAccount) => {
            console.log('CREATED', newAccount)

            let obj = {
              BANK_ACCOUNT: 'Transferencia',
              INSTANT_PAYMENT: 'Pago móvil',
              OTHER_ACCOUNT: 'Otro',
            }
            let newUnionAccount = {
              ...newAccount,
              document: {
                document: newAccount.document,
                documentType: newAccount.document_type,
              },
              typeAccount: newAccount.bank_account_type,
              accountNumber: newAccount.accountNumber,
              id: newAccount.id,
              name: newAccount.name,
              accountName:
                newAccount.bank ||
                newAccount.payment_method ||
                newAccount.paymentMethod,
              number:
                newAccount.accountNumber ||
                newAccount.phone ||
                newAccount.description,
              method: obj[newAccount.moneyAccountType],
            } as any
            console.log('CREATED', newUnionAccount)
            setUnionAccounts((prevState) => [...prevState, newUnionAccount])
          }}
        />
      </Modal>

      <Modal
        display={modal}
        // modalClasses="w-3/6 py-4 px-12"
        scroll="scroll"
        onAccept={() => null}
        onClose={() => {
          setModal(false)
          setSelected(null)
        }}
      >
        <DealersForm
          useType={selected === null ? 'create' : 'edit'}
          onSubmit={onSubmit}
          defaultValues={selected}
          onCancel={() => {
            setModal(false)
            setSelected(null)
          }}
        />
      </Modal>

      <ModalViewWithTabs
        display={modalFromRow}
        onClose={() => {
          setModalFromRow(false)
          setDataWithTabs([])
        }}
        dataWithTabs={dataWithTabs}
      />

      {/* <Modal
        display={searchModal}
        // modalClasses="w-2/5 py-4 px-8"
        scroll="visible"
        onAccept={() => null}
        onClose={() => {
          setSearchModal(false)
        }}
      >
        <SearchDealersForms
          setSearchModal={setSearchModal}
          setSearchParams={setSearchParams}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
          setLoading={setLoading}
        ></SearchDealersForms>
      </Modal> */}

      <FloatingForm
        visible={searchModal}
        onClose={() => setSearchModal(false)}
        topClass="top-16"
        rightClass="right-10"
        containerClass="w-2/6"
      >
        {/* <SearchDealersForms
          setSearchModal={setSearchModal}
          setSearchParams={setSearchParams}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
          setLoading={setLoading}
        ></SearchDealersForms> */}
        <AdvancedClientsForm
          onCloseAdvancedForm={() => setSearchModal(false)}
          type="DEALERS"
          onSubmit={(values) => {
            let params = Object.keys(values).reduce((a, b) => {
              if (values[b] !== '') {
                return [...a, `${b}=${values[b]}`]
              }
              return a
            }, [] as any)
            // setSearchParams(params)

            getDealers(params, currentPage)

            // if (currentPage === 0) {
            //   setLoading(true)
            //   fetchDealers(params, [
            //     `pageNumber=${currentPage + 1}`,
            //     `pageSize=${userConfig.rowsPerPage}`,
            //   ])
            //   setLoading(false)
            //   setSearchModal(false)
            // } else {
            //   setCurrentPage(0)
            // }
          }}
        />
      </FloatingForm>

      <Modal
        display={showDocuments}
        onAccept={() => null}
        onClose={() => {
          setShowDocuments(false)
          setSelected(null)
        }}
      >
        <h1 className="text-center mb-2">Documentos</h1>
        <div className="grid grid-cols-3">
          {console.log('VER ', selected)}
          {selected &&
            selected?.documents &&
            selected?.documents?.map((document) => (
              <div className="shadow-lg rounded-lg p-4 mb-5 mr-5 text-xl flex flex-col relative m-auto dark:bg-gray-800 w-2/3">
                <img
                  src={
                    document.url.endsWith('.docx')
                      ? docxImage
                      : document.url.endsWith('pdf')
                      ? pdfImage
                      : document.url.endsWith('xlsx')
                      ? excelImage
                      : fileBlueImage
                  }
                  alt="imageUpload"
                  className="h-28 object-contain rounded-3xl dark:border-gray-700"
                />
                <div className="flex flex-row justify-between items-center mt-2">
                  <div>
                    <h1
                      style={{
                        maxWidth: '105px',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}
                      className="text-sm"
                    >
                      {returnNameByRegex(document.url)}
                    </h1>
                  </div>
                  <FloatingMenu
                    onClose={() => {
                      setSelectedDocument(null)
                    }}
                    visible={selectedDocument === document.id}
                    options={{
                      onDelete: async () => {
                        try {
                          addAlert({
                            message: 'Eliminando documento...',
                            status: 'loading',
                          })
                          await deleteDocumentDealer(
                            document.id,
                            document.url.replace(/https:\/\//, ''),
                            selected.id
                          )
                          addAlert({
                            message: 'Documento eliminado con éxito',
                            status: 'success',
                          })
                        } catch (err) {
                          addAlert({
                            message: 'Error al eliminar documento',
                            status: 'error',
                          })
                        }
                      },
                      onDownload: () => window.open(`${document.url}`),
                    }}
                  >
                    <HiDotsVertical
                      className="cursor-pointer text-gray-400"
                      onClick={() => setSelectedDocument(document.id)}
                    />
                  </FloatingMenu>
                </div>
              </div>
            ))}

          {selected?.documents.length === 0 && (
            <div className="col-span-5">
              <Empty
                animationProps={{
                  animation: DocumentAnimation,
                  width: 350,
                  height: 350,
                }}
              >
                <p className="font-semibold max-w-xs text-center my-4 text-sm text-coolGray-500">
                  No hay documentos, añadelos.
                </p>
              </Empty>
            </div>
          )}
        </div>
      </Modal>

      <Modal
        display={showModalAccountFormEdit}
        onClose={() => setShowModalAccountFormEdit(false)}
      >
        <AccountsUpdate
          selectedEditAccount={selectedEditAccount}
          onClose={() => setShowModalAccountFormEdit(false)}
          onSubmit={async (values) => {
            console.log('Values...', values)
            console.log('selected', selected)
            let body = {
              ...values,
              idProvider: selected?.id,
              moneyAccountType: values.method,
            }

            try {
              addAlert({
                message: 'Modificando Cuenta...',
                status: 'loading',
              })
              let response = await axios.patch(
                `${server}/thirdparty/provider-account`,
                body
              )
              console.log('in...')
              await getAndFormatAccounts(selected)
              addAlert({
                message: 'Cuenta modificada satisfactoriamente.',
                status: 'success',
              })
            } catch (err) {
              addAlert({
                message: 'Error al modificar cuenta',
                status: 'error',
              })
            }

            // let accountData = response.data.account

            // let newAccountUnion = unionAccounts.map(v => {
            //   if (v.id === accountData.id) {
            //     return {

            //       ...v,
            //       document: {document: accountData.document, documentType: accountData.document_type},
            //       accountNumber: accountData.account_number,
            //       bankAccountType: accountData.bank_account_type,
            //       accountName: accountData.bank,
            //       number: accountData.account_number
            //     }
            //   }
            //   return v
            // })
            // console.log("new account union", newAccountUnion)
            // setUnionAccounts(newAccountUnion)
          }}
        />
      </Modal>

      <ModalConfirm
        title="¿Está seguro que desea eliminar el proveedor?"
        displayConfirmModal={confirmModal}
        onCancel={() => setConfirmModal(false)}
        onConfirm={async () => {
          setConfirmModal(false)
          await onDelete(dealerToDelete)
          await getDealers([], 0)
          // if (currentPage === 0) {
          //   setSearchParams([])
          //   setLoading(true)
          //   try {
          //     await fetchDealers(
          //       [],
          //       [
          //         `pageNumber=${currentPage + 1}`,
          //         `pageSize=${userConfig.rowsPerPage}`,
          //       ]
          //     )
          //   } catch (e) {
          //     console.log('Server error')
          //   } finally {
          //     setLoading(false)
          //   }
          //   // setLoading(false)
          // } else {
          //   setCurrentPage(0)
          // }
        }}
      />

      <ModalConfirm
        title="¿Está seguro que desea eliminar la cuenta?"
        displayConfirmModal={confirmModalAccount}
        onCancel={() => setConfirmModalAccount(false)}
        onConfirm={async () => {
          try {
            addAlert({
              message: 'Eliminando cuenta...',
              status: 'loading',
            })
            let response = await axios.delete(
              `${server}/thirdparty/provider-account?id=${selectedAccountToDeleteId}`
            )
            setUnionAccounts((prevState) => [
              ...prevState.filter(
                (v) =>
                  v.id !== response.data.account.id.id_provider_money_account
              ),
            ])
            addAlert({
              message: 'Cuenta eliminada satisfactoriamente',
              status: 'success',
            })
          } catch (err) {
            addAlert({
              message: 'Error al eliminar cuenta',
              status: 'error',
            })
          } finally {
            setConfirmModalAccount(false)
          }
        }}
      />
    </>
  )
}

const mapState = ({ deal }: State) => ({
  dealers: deal.dealers,
  numberOfPages: deal.numberOfPages,
})

const connector = connect(mapState, {
  fetchDealers,
  createDealer,
  updateDealer,
  removeDealer,
  onEnableDealer,
  deleteDocumentDealer,
})

export default connector(Dealers)

type PropsFromRedux = ConnectedProps<typeof connector>

interface DealersProps {
  setHeaderActions: React.Dispatch<
    React.SetStateAction<HeaderProps['headerActions'] | null | undefined>
  >
}
